/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function () {
  var SELECTORS = {
    section: '[data-section-type="collection"]',
    dynamicPart: '.collection__dynamic-part',
    productList: '.product-list--collection',
    pagination: '.pagination',
    nextLink: '.pagination__next'
  };

  var loadingClass = 'is-loading-next-page';
  var initializedSections = new WeakSet();


  function normalizeFilterSearchValue(value) {
    var normalizedValue = String(value || '').trim().toLocaleLowerCase();

    // Make searches such as "smykker" match labels containing accented characters too.
    if (normalizedValue.normalize) {
      normalizedValue = normalizedValue.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    return normalizedValue;
  }

  function updateFilterSearch(searchInput) {
    var filterGroup = searchInput.closest('.collection__filter-collapsible');

    if (!filterGroup) {
      return;
    }

    var query = normalizeFilterSearchValue(searchInput.value);

    filterGroup.querySelectorAll('.collection__filter-checkbox').forEach(function (option) {
      var label = normalizeFilterSearchValue(option.getAttribute('data-filter-label') || option.textContent);
      var isMatch = query === '' || label.indexOf(query) !== -1;

      option.classList.toggle('is-filter-search-hidden', !isMatch);
    });
  }

  document.addEventListener('input', function (event) {
    var target = event.target;
    var searchInput = target && target.closest ? target.closest('.collection__filter-search-input') : null;

    if (searchInput) {
      updateFilterSearch(searchInput);
    }
  });

  
  function buildSectionUrl(url, sectionId) {
    var sectionUrl = new URL(url.href);
    sectionUrl.searchParams.set('section_id', sectionId);
    return sectionUrl.toString();
  }

  function getNextUrl(section) {
    var nextLink = section.querySelector(SELECTORS.nextLink);

    if (!nextLink) {
      return null;
    }

    return new URL(nextLink.getAttribute('href'), window.location.origin);
  }

  function updateProductsCount(section, sourceDocument) {
    var countJson = sourceDocument.querySelector('[data-collection-products-count]');
    var totalCount = section.querySelector('.collection__products-count-total');

    if (!countJson) {
      return;
    }

    try {
      var count = JSON.parse(countJson.textContent);

      if (totalCount && count.productsCount) {
        totalCount.innerHTML = count.productsCount;
      }
    } catch (error) {
      return;
    }
  }

  function markComplete(section) {
    var pagination = section.querySelector(SELECTORS.pagination);

    if (pagination) {
      pagination.remove();
    }
  }

  function replacePagination(section, sourceDocument) {
    var currentPagination = section.querySelector(SELECTORS.pagination);
    var nextPagination = sourceDocument.querySelector(SELECTORS.pagination);

    if (currentPagination && nextPagination) {
      currentPagination.replaceWith(nextPagination);
    } else if (currentPagination) {
      markComplete(section);
    }
  }

  function loadNextPage(section) {
    if (section.classList.contains(loadingClass)) {
      return;
    }

    var nextUrl = getNextUrl(section);
    var sectionId = section.getAttribute('data-section-id');
    var productList = section.querySelector(SELECTORS.productList);

    if (!nextUrl || !sectionId || !productList) {
      return;
    }

    section.classList.add(loadingClass);

    fetch(buildSectionUrl(nextUrl, sectionId), {
      credentials: 'same-origin',
      method: 'GET'
    }).then(function (response) {
      return response.text();
    }).then(function (content) {
      var container = document.createElement('div');
      container.innerHTML = content;

      var nextProductList = container.querySelector(SELECTORS.productList);

      if (!nextProductList) {
        markComplete(section);
        return;
      }

      Array.prototype.slice.call(nextProductList.children).forEach(function (productItem) {
        productList.appendChild(productItem);
      });

      replacePagination(section, container);
      updateProductsCount(section, container);

      document.dispatchEvent(new CustomEvent('collection:infinite-scroll:loaded', {
        bubbles: true,
        detail: {
          url: nextUrl.toString()
        }
      }));
    }).catch(function () {
      var pagination = section.querySelector(SELECTORS.pagination);

      section.infiniteScrollDisabled = true;

      if (pagination) {
        pagination.classList.remove('pagination--infinite');
      }
    }).finally(function () {
      section.classList.remove(loadingClass);
      observePagination(section);
    });
  }

  function observePagination(section) {
    if (section.infiniteScrollObserver) {
      section.infiniteScrollObserver.disconnect();
    }

    if (section.infiniteScrollDisabled) {
      return;
    }

    var nextLink = section.querySelector(SELECTORS.nextLink);
    var pagination = section.querySelector(SELECTORS.pagination);

    if (!nextLink || !pagination) {
      if (pagination) {
        markComplete(section);
      }

      return;
    }

    pagination.classList.add('pagination--infinite');

    section.infiniteScrollObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          loadNextPage(section);
        }
      });
    }, {
      rootMargin: '700px 0px 700px 0px'
    });

    section.infiniteScrollObserver.observe(pagination);
  }

  function initCollectionInfiniteScroll(section) {
    // V2 uses deliberate, URL-backed pagination. Do not append stale pages
    // from the legacy infinite-scroll observer after filtering or sorting.
    if (!section || section.classList.contains('netlager-collection') || initializedSections.has(section)) {
      return;
    }

    initializedSections.add(section);
    observePagination(section);

    section.addEventListener('click', function (event) {
      var nextLink = event.target.closest(SELECTORS.nextLink);

      if (!nextLink || !section.contains(nextLink)) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      loadNextPage(section);
    }, true);

    var dynamicPart = section.querySelector(SELECTORS.dynamicPart);

    if (dynamicPart) {
      new MutationObserver(function () {
        observePagination(section);
      }).observe(dynamicPart, {
        childList: true,
        subtree: false
      });
    }
  }

  function initAllCollectionInfiniteScroll() {
    if (!('IntersectionObserver' in window) || window.theme && window.theme.pageType !== 'collection') {
      return;
    }

    document.querySelectorAll(SELECTORS.section).forEach(initCollectionInfiniteScroll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCollectionInfiniteScroll);
  } else {
    initAllCollectionInfiniteScroll();
  }
})();
